/* eslint-disable prettier/prettier */
import React, { useState, useEffect } from 'react';
import { db, firebase, sendEmail } from "firebase/fbConfig.js";
import { connect } from 'react-redux';
import compose from 'recompose/compose';

import DateTimePicker from 'react-datetime-picker'

import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Button from "components/CustomButtons/Button.jsx";

import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import InputLabel from "@material-ui/core/InputLabel";
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';

import styles from "assets/jss/material-dashboard-pro-react/components/ActionSubmitFormStyle.jsx";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";

import withStyles from "@material-ui/core/styles/withStyles";

const INITIAL_STATE = {
    taskDescription: '',
    dispatcherSelected: '',
    taskDueDate: null,
    snackInfo: {
        open: false
    }
}
function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}


class TaskCreator extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
                haneyDispatchers:[],
                taskDescription: '',
                dispatcherSelected: '',
                taskDueDate: null,
                snackInfo: {
                open: false
            }
          };


        this.dispatchers = [
            {
                id: '',
                name: ''
            },
            {
                id: 'qqU3x36qMufJ1U4Olc7r0f53e192',
                name: 'Kevin Kersting'
            },
            {
                id: '9WJzXP5ygWeMrKt7iUcjoEZsibd2',
                name: 'Angie Cutler'
            },
            {
                id: 'LlCEBfIytWYMz9BO3J0N2nZ7DS32',
                name: 'Kyle Cannizzaro'
            },
            {
                id: 'WLEHqu72JvaZircsTWkeoW5W0mH2',
                name: 'Justin Oberg'
            },
            {
                id: 'm9FqggtB3TbzgAw5Tb8nTIr9VYG3',
                name: 'Chris Castro'
            }
        ]
    }

    componentDidMount() {
        this.getHaneyDispatchers();
    }

    handleChange = (e) => {
        this.setState({ [e.target.id]: e.target.value });
    }

    handleSelectChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    }

    handleDateTimeChange = (date) => {
        this.setState({
            taskDueDate: date
        })
    }

    getHaneyDispatchers = () => {
        // debugger;
        db.collection('haney-vendors').doc('SdmzdeID9QfexkQymvqU').collection('users').where('role', '==', 'Employee').get()
            .then(snapshot => {
                const haneyDispatchers = snapshot.docs.map(doc => ({
                    id: doc.id,
                    ...doc.data()
                })).map(doc => ({
                    id: doc.id,
                    name: doc.name
                }));

                this.setState({
                    haneyDispatchers
                })
            })
    }
    closeSnack = (snack) => {
        this.setState((prevState) => (prevState.snackInfo.open = false));
    };

    createTask = () => {
        console.log("Creating task!");

        let taskObj;

        console.log(this.props.entityID)

        if (this.props.entityID) {
            taskObj = {
                instanceOwner: 'Haney Freightways',
                assignedTo: this.state.dispatcherSelected,
                taskAssignee: this.state.haneyDispatchers.find(d => d.id === this.state.dispatcherSelected),
                taskAssigner: {
                    name: `${this.props.user.firstName} ${this.props.user.lastName}`,
                    id: this.props.user.uid
                },
                taskDescription: this.state.taskDescription,
                taskDueDate: this.state.taskDueDate,
                taskAssignedAt: new Date(),
                entityID: this.props.entityID,
                profileType: this.props.profileType,
                name: this.props.name
                // freightBillNumber: this.props.freightBillNumber
            }
        } else {
            taskObj = {
                instanceOwner: 'Haney Freightways',
                assignedTo: this.state.dispatcherSelected,
                taskAssignee: this.state.haneyDispatchers.find(d => d.id === this.state.dispatcherSelected),
                taskAssigner: {
                    name: `${this.props.user.firstName} ${this.props.user.lastName}`,
                    id: this.props.user.uid
                },
                taskDescription: this.state.taskDescription,
                taskDueDate: this.state.taskDueDate,
                taskAssignedAt: new Date(),
                orderID: this.props.orderID,
                freightBillNumber: this.props.freightBillNumber,
            }
        }

        console.log(Object.values(taskObj).filter(Boolean))

        if (Object.values(taskObj).filter(Boolean).length === Object.values(taskObj).length) {
            db.collection('tasks').add(taskObj)
                .then(() => this.setState(INITIAL_STATE));
            this.setState({
                snackInfo: {
                    open: true,
                    severity: 'success',
                    message: "New Task Created"
                }
            })
        } else {
            console.log("Errors");
            this.setState({
                snackInfo: {
                    open: true,
                    severity: "error",
                    message: "missing required fields"
                }
            })
        }

    }

    render() {
        const { classes } = this.props;

        console.log(this.state);
        console.log(this.props);

        return (
            <GridContainer>
                <GridItem xs={12}>
                    <p>
                        <b>Create Task</b>
                    </p>
                </GridItem>
                {console.log("DISPATCHERS", this.state.haneyDispatchers)}
                <GridItem xs={12}>
                    <FormControl
                        fullWidth
                        className={classes.selectFormControl}>
                        <InputLabel
                            htmlFor="dispatcherSelected"
                            className={classes.selectLabel}>
                            Dispatchers:
                        </InputLabel>
                        <Select
                            MenuProps={{
                                className: classes.selectMenu
                            }}
                            classes={{
                                select: classes.select
                            }}
                            value={this.state.dispatcherSelected}
                            onChange={this.handleSelectChange}
                            inputProps={{
                                id: 'dispatcherSelected',
                                name: 'dispatcherSelected'
                            }}
                        >
                            {
                                [...this.state.haneyDispatchers].map((dispatcher, i) => (
                                    <MenuItem
                                        classes={{
                                            root: classes.selectMenuItem
                                        }}
                                        value={dispatcher.id}
                                        key={i}
                                    >{dispatcher.name}</MenuItem>
                                ))
                            }
                        </Select>
                    </FormControl>
                    <br />
                    <br />
                </GridItem>
                <GridItem xs={12}>
                    <CustomInput
                        labelText="Task Notes"
                        id="taskDescription"
                        formControlProps={{
                            fullWidth: true
                        }}
                        inputProps={{
                            required: false,
                            type: "text",
                            multiline: true,
                            onChange: (event) => this.handleChange(event),
                            value: this.state.taskDescription
                        }}
                    />
                </GridItem>
                <GridItem xs={12}>
                    Due Date:
                    <br />
                    <DateTimePicker
                        onChange={this.handleDateTimeChange}
                        value={this.state.taskDueDate}
                    />
                    <br />
                    <br />
                </GridItem>
                <GridItem xs={6}>
                    <Button
                        color='primary'
                        fullWidth
                        onClick={this.createTask}
                    >
                        CREATE TASK
                    </Button>
                </GridItem>
                <Snackbar
                    open={this.state.snackInfo.open}
                    autoHideDuration={6000}
                    onClose={this.closeSnack}
                >
                    <Alert
                        onClose={this.closeSnack}
                        severity={this.state.snackInfo.severity}
                    >
                        {this.state.snackInfo.message}
                    </Alert>
                </Snackbar>
            </GridContainer>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    //console.log(state)
    return {
        AuthBool: !!state.auth.user,
        authUser: state.auth.user,
        user: state.profile.user,
        // orderID: ownProps.match.params.id
    }
}

export default compose(
    connect(mapStateToProps),
    withStyles(styles)
)(TaskCreator);


// WEBPACK FOOTER //
// ./src/components/Forms/TaskCreatorForm.jsx